"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var material_2 = require("@mui/material");
require("./Checkbox.css"); // Import the CSS file
var Checkbox = function (_a) {
    var _b = _a.backgroundColor, backgroundColor = _b === void 0 ? '#a8a7b4' : _b, _c = _a.checkedColor, checkedColor = _c === void 0 ? 'white' : _c, _d = _a.color, color = _d === void 0 ? 'white' : _d, _e = _a.size, size = _e === void 0 ? 'medium' : _e, _f = _a.borderRadius, borderRadius = _f === void 0 ? '2px' : _f, className = _a.className, id = _a.id, label = _a.label, _g = _a.themeMode, themeMode = _g === void 0 ? 'light' : _g, // Default to light theme
    props = __rest(_a, ["backgroundColor", "checkedColor", "color", "size", "borderRadius", "className", "id", "label", "themeMode"]);
    var checkboxStyle = {
        color: color,
        '&.Mui-checked': {
            color: checkedColor,
        },
        '& .MuiSvgIcon-root': {
            backgroundColor: themeMode === 'dark' ? '#535167' : backgroundColor,
            borderRadius: borderRadius,
        },
    };
    return (react_1.default.createElement(material_2.FormControlLabel, { control: react_1.default.createElement(material_1.Checkbox, __assign({ id: id, className: className, sx: checkboxStyle, size: size }, props)), label: label }));
};
exports.default = Checkbox;
